import { BaSeDataTable, BaSeTheme } from '@base/react';
import React from 'react';
import { useTableInterview } from '../../context/table-interview-context';

function CommonTable({
  configTable,
  columnConfig,
  hasCustomFilter,
  textFilter,
  getSelectionIconActions,
  buildCustomFilter,
  setItemsSelectTable,
  setIsAllSelect,
  cache,
  cacheKeySebrae,
}) {
  const { fetchData, data, loading, clearAll } = useTableInterview();

  React.useEffect(() => {
    const elemento = [...document.querySelectorAll('small')].find(
      (el) => el.textContent.trim() === 'Filtros',
    );
    if (elemento) {
      elemento.style.display = 'none';
    }
  }, []);

  return (
    <BaSeDataTable
      singularItemDescription="candidato"
      pluralItemDescription="candidatos"
      genderOfItemDescription="male"
      config={configTable}
      columnConfig={columnConfig}
      fetchData={fetchData}
      backgroundColor={BaSeTheme.colors.defaultColors.white}
      foregroundColor={BaSeTheme.colors.institucionais.cinzaSebrae60}
      highlightedColor={BaSeTheme.colors.institucionais.cinzaSebrae30}
      separatorColor={BaSeTheme.colors.institucionais.cinzaSebrae90}
      filterAreaBackgroundColor={BaSeTheme.colors.defaultColors.white}
      hasPagination
      hasSorting
      hasSelection
      hasCustomFilter
      textFilterAlwaysVisible
      customFilterIconVisible={false}
      customFilterVisible={hasCustomFilter}
      initialPageSize={10}
      isLoading={loading}
      items={data.items}
      total={data.total}
      title=""
      initialSortType="DESC"
      initialSortField="interviewDate"
      hasTextFilter
      textFilterWidth={345}
      textFilterPlaceholder={`Pesquisar por nome, e-mail, CPF e telefone`}
      onTextFilter={({ setFilter, term }) => {

        textFilter(setFilter, term);
      }}
      configActionItemsProps={{ icon: 'ellipsis-v' }}
      selectionIconActions={({ isAllSelected, selectedItems }) => {
        getSelectionIconActions(isAllSelected, selectedItems);
        return [];
      }}
      renderCustomFilter={({ setFilter }) => {
        return buildCustomFilter(setFilter);
      }}
      selectionButtonActions={({
        isAllSelected,
        selectedItems,
        reloadData,
      }) => {
        setItemsSelectTable(selectedItems);
        setIsAllSelect(isAllSelected);
        return [];
      }}
      onClearFilter={({ resetSelection }) => {
        clearAll();
        resetSelection();
      }}
    />
  );
}

export default CommonTable;
